import { useMemo } from 'react'

export const useCharactersLeft = (maxLength: number, charsEntered: number) => {
  return useMemo(
    () => `${Math.max(maxLength - (charsEntered ?? 0), 0)} Characters Left`,
    [maxLength, charsEntered],
  )
}
